import { Box, VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useI18n } from '@springbig/shared';
import { SpIcon } from '~/shared/Icon';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useModalStyles } from '~/shared/styles';
import React from 'react';

const SuspendedMerchantScreen = () => {


    const { t } = useI18n();
    const {
        icon,
        text,
        body_background,
        overlay_background
    } = useModalStyles();

    return (
        <VStack
            position={'fixed'}
            left={0}
            top={0}
            w={'100%'}
            h={'100%'}
            justifyContent={'center'}
            alignItems={'center'}
            p={4}
        >
            <Box
                background={overlay_background}
                opacity={.3}
                position={'absolute'}
                top={0}
                bottom={0}
                left={0}
                right={0}
            />
            <VStack
                background={body_background}
                px={4}
                py={8}
                rounded={10}
                maxW={'420px'}
                minW={'320px'}
                overflowY={'auto'}
                alignItems={'center'}
                space={8}
                shadow={8}
            >
                <SpIcon icon={faTriangleExclamation} color={icon} size={72}/>
                <Caption color={text} textAlign={'center'}>{ t('suspended_account.disclaimer') }</Caption>
            </VStack>
        </VStack>
    );
};

export default SuspendedMerchantScreen;
